import { assertNonEmpty } from '../shared/branded-id';

export type SegmentId = string & { readonly __brand: 'SegmentId' };

export function SegmentId(raw: string): SegmentId {
  return assertNonEmpty(raw.trim(), raw, 'SegmentId') as SegmentId;
}

const URL_SUFFIX_LENGTH = 6;

/**
 * The last six alphanumerics of a comparison id: what a /portal/compare/<slug>-<id6> URL
 * matches on, so a rename never breaks a link (see segment-url.ts).
 */
export function segmentIdSuffix(id: string): string {
  return id.replace(/-/g, '').toLowerCase().slice(-URL_SUFFIX_LENGTH);
}
